import React from 'react';
import { PAST_PICKUPS_GRID_FILTERS } from '../../Constants';
import { withStyles } from '@material-ui/core';
import StyledToolTip from '../../../../../../../common/StyledToolTip';
import { getPickupStatusTypeIcon } from '../../../../utils/pickupStatusTypeIcon';
import { getPickupStatus } from '../../utils';

const styles = (theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  pickupNumber: {
    paddingRight: 4
  }
});

const PickupNumber = ({ classes, theme, data }) => {
  const pickupStatus = getPickupStatus(data);
  const getTitle = (value) => {
    switch (value) {
      case PAST_PICKUPS_GRID_FILTERS.completed:
        return 'Completed Pickup';
      case PAST_PICKUPS_GRID_FILTERS.voided:
        return 'Voided Pickup';
      case PAST_PICKUPS_GRID_FILTERS.noFreight:
        return 'No Freight Pickup';
      default:
        return null;
    }
  };

  return (
    <div className={classes.container}>
      <span className={classes.pickupNumber}>{data.pickupNumber}</span>
      <StyledToolTip title={getTitle(pickupStatus)}>
        <div>{getPickupStatusTypeIcon({ status: pickupStatus, theme })}</div>
      </StyledToolTip>
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(PickupNumber);
